export default __webpack_public_path__ + "static/media/process_corporate_EN.4782574a.jpg";